import { useQuery } from "@apollo/client"
import {
  ALL_GAMES,
  ALL_GAMES_WITH_SEASONS,
  ALL_GAMES_WITH_ALL_SEASONS,
  GET_GAME_BY_ID,
  GET_ACTIVE_GAMES,
} from "../queries/games"
import type { Game } from "../types"

export const useAllGames = (onlyActives = true) => {
  const { data, loading, error, refetch } = useQuery<{ allGames: Game[] }>(ALL_GAMES)

  const games =
    data?.allGames?.filter((game) => {
      if (onlyActives) {
        return game.isActive === 1
      } else {
        return game.id
      }
    }) || []

  return {
    games,
    gamesMap: games.reduce((acc, game) => {
      acc.set(game.id, game)
      return acc
    }, new Map()),
    loading,
    error,
    refetch,
  }
}

export const useGame = (id: number) => {
  const { data, loading, error, refetch } = useQuery<{ game: Game }>(GET_GAME_BY_ID, {
    variables: { id },
    errorPolicy: "all",
    skip: !id,
  })

  return {
    game: data?.game,
    loading,
    error,
    refetch,
  }
}

export const useActiveGames = () => {
  const { data, loading, error, refetch } = useQuery<{ games: Game[] }>(GET_ACTIVE_GAMES, {
    errorPolicy: "all",
  })

  return {
    games: data?.games || [],
    loading,
    error,
    refetch,
  }
}

export const useAllGamesWithSeasons = (
  onlyActives = true,
  { isAdmin = false, isAuthenticated = false },
) => {
  const SEARCH = isAuthenticated && isAdmin ? ALL_GAMES_WITH_ALL_SEASONS : ALL_GAMES_WITH_SEASONS

  const { data, loading, error, refetch } = useQuery<{ allGames: Game[] }>(SEARCH)

  return {
    games:
      data?.allGames?.filter((game) => {
        if (onlyActives) {
          return game.isActive === 1
        } else {
          return game.id
        }
      }) || [],
    loading,
    error,
    refetch,
  }
}
